import React from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';
import Button from '../Button/Button.js';
import Modal from './Modal.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * ModalTrigger to show a Modal primitive when a button is pressed.
 *
 * It accepts a function as children, which is called with a callback that closes the modal.
 *
 */
const ModalTrigger = ({
  label,
  children,
  ...props
}) => {
  const ref = React.useRef(null);
  const state = useOverlayTriggerState(props);
  const {
    triggerProps,
    overlayProps
  } = useOverlayTrigger({
    type: 'dialog'
  }, state, ref);
  const {
    isOpen,
    close,
    setOpen,
    toggle,
    open
  } = state;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, triggerProps, "Open Dialog"), isOpen && /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    state: state
  }), /*#__PURE__*/React.cloneElement(children(close), overlayProps)));
};
var ModalTrigger$1 = ModalTrigger;

export { ModalTrigger$1 as default };
